import { HeadContent, type StaticDataRouteOption } from '@tanstack/react-router';
import { memo } from 'react';
import { createPortal } from 'react-dom';
import { MIDDOT_SYMBOL } from '@/utils/constants';

/**
 * @see https://github.com/TanStack/router/discussions/1056#discussioncomment-12306354
 */
export const Head = memo(function Head() {
  const container = document.querySelector('head');
  if (!container) {
    return null;
  }

  container.querySelector('title')?.remove();
  return createPortal(<HeadContent />, container);
});

/**
 * `ctx` is typed down to the one field this reads instead of `AnyRouteMatch`. Under file-based routing a
 * route's generics are resolved through the `FileRoutesByPath` chain, and a `head` whose parameter names
 * a full route match sends TypeScript back through the route it is still inferring — the cycle collapses
 * that route's search, params and context to `any`. This shape names no route type, so nothing recurses.
 *
 * @see https://github.com/TanStack/router/discussions/1056#discussioncomment-12272328
 */
export function head(ctx: { matches: { staticData: StaticDataRouteOption }[] }) {
  const parts = ctx.matches.flatMap((m) => m.staticData.title).filter(Boolean);

  return {
    meta: [{ title: parts.join(` ${MIDDOT_SYMBOL} `) }],
  };
}
